import {
  SingleLevelSelectorCursorPaginationHelper,
  SingleLevelSelectorOffsetPaginationHelper
} from '../components/single-level-selector/paginationHelpers';

export function getSingleLevelSelectorPaginationStrategy(paginationStrategy: 'cursor' | 'offset') {
  if (paginationStrategy === 'cursor') {
    return new SingleLevelSelectorCursorPaginationHelper();
  }

  return new SingleLevelSelectorOffsetPaginationHelper();
}
